import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { DownloadCard } from '../components/DownloadCard';
import { downloads } from '../data/downloads';
export function Policies() {
  const policyDocs = downloads.filter(d => d.category === 'Policies');
  return <div className="w-full bg-club-canvas pb-24" data-id="element-1215">
      <PageBanner title="Club Policies" eyebrow="Governance" image="https://images.unsplash.com/photo-1589829085413-56de8ae18c73?ixlib=rb-4.0.3&auto=format&fit=crop&w=2112&q=80" data-id="element-1216" />

      <div className="max-w-4xl mx-auto px-4 mt-20" data-id="element-1217">
        <div className="bg-white p-8 md:p-12 border border-club-border rounded-sm mb-12" data-id="element-1218">
          <h2 className="text-3xl mb-6 text-club-green" data-id="element-1219">Privacy Policy</h2>
          <div className="prose prose-club max-w-none text-club-ink/80 text-sm leading-relaxed space-y-4" data-id="element-1220">
            <p data-id="element-1221">
              <strong data-id="element-1222">Last Updated: January 1, 2026</strong>
            </p>
            <p data-id="element-1223">
              Andhra Social & Cultural Association ("we", "our", or "us") is
              committed to protecting your privacy. This Privacy Policy explains
              how we collect, use, disclose, and safeguard your information when
              you visit our website or use our services.
            </p>
            <h3 className="text-xl font-serif text-club-green mt-6 mb-2" data-id="element-1224">
              1. Information We Collect
            </h3>
            <p data-id="element-1225">
              We may collect personal information that you voluntarily provide
              to us when you register for an account, express an interest in
              obtaining information about us or our products and services, or
              otherwise contact us. The personal information that we collect
              depends on the context of your interactions with us.
            </p>
            <h3 className="text-xl font-serif text-club-green mt-6 mb-2" data-id="element-1226">
              2. How We Use Your Information
            </h3>
            <p data-id="element-1227">
              We use personal information collected via our website for a
              variety of business purposes described below. We process your
              personal information for these purposes in reliance on our
              legitimate business interests, in order to enter into or perform a
              contract with you, with your consent, and/or for compliance with
              our legal obligations.
            </p>
          </div>
        </div>

        <h2 className="text-3xl mb-8 text-club-green text-center" data-id="element-1228">
          Policy Documents
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1229">
          {policyDocs.map(doc => <DownloadCard key={doc.id} title={doc.title} type={doc.type} size={doc.size} data-id="element-1230" />)}
          <DownloadCard title="Terms of Service" type="PDF" size="1.2 MB" data-id="element-1231" />
          <DownloadCard title="Cookie Policy" type="PDF" size="0.5 MB" data-id="element-1232" />
        </div>
      </div>
    </div>;
}